import React from 'react';
import Image from 'next/image';
import { CodexStrip } from '../icons';
import logo from '../../public/img/logos/logo-carreras-light.png';

export default function Footer() {
  return (
    <div className="mt-28">
      <CodexStrip />
      <div className="flex p-12 items-center justify-center">
        <Image src={logo} width={300} height={294} alt="Carreras logo" />
      </div>
    </div>
  );
}
